import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useParallax } from "./hooks/useParallax";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Crew from "./components/Crew";
import Tickets from "./components/Tickets";
import Venue from "./components/Venue";
import FAQ from "./components/FAQ";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import CharlotteSpecialRam from "./pages/CharlotteSpecialRam";
import CharlotteLanding from "./pages/CharlotteLanding";
import MetaDiscountForm from "./pages/MetaDiscountForm";
import RamFansDiscountLanding from "./pages/RamFansDiscountLanding";
import RamGiftCardLanding from "./pages/RamGiftCardLanding";

function Home() {
  useParallax();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));

    const mutationObserver = new MutationObserver(() => {
      document.querySelectorAll(".reveal:not(.active)").forEach((el) => observer.observe(el));
    });
    mutationObserver.observe(document.getElementById("root"), { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      mutationObserver.disconnect();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] selection:bg-[#C9ED00] selection:text-black">
      <div className="noise-overlay" />
      <Navbar />
      <Hero />
      <Crew />
      <Tickets />
      <Venue />
      <FAQ />
      <FinalCTA />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/charlotte-special-ram" element={<RamFansDiscountLanding />} />
        <Route path="/meta-discount-charlotte" element={<CharlotteLanding source="meta" />} />
        <Route path="/charlotte-form" element={<CharlotteSpecialRam />} />
        <Route path="/meta-discount" element={<RamFansDiscountLanding />} />
        <Route path="/meta-discount-form" element={<MetaDiscountForm />} />
        <Route path="/ram-miriyala-daaru-desi-discount" element={<RamFansDiscountLanding />} />
        <Route path="/ram-raleigh-deal" element={<RamGiftCardLanding />} />
      </Routes>
    </BrowserRouter>
  );
}
